import { DEFAULT_CATALOGUE_PRODUCT } from './catalogueProducts';

export const STAFF_URL = '/staff';
export const DEFAULT_STAFF_PATH = `${STAFF_URL}/catalogue/${DEFAULT_CATALOGUE_PRODUCT}`;
export const STAFF_ORGANISATIONS_PATH = `${STAFF_URL}/organisations`;
